import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./NavDrawer.css";

const NavDrawer = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const { products, services } = useSelector((state) => state.data);

  useEffect(() => {
    document.documentElement.style.overflow = isOpen ? "hidden" : "";
    return () => { document.documentElement.style.overflow = ""; };
  }, [isOpen]);

  const handleSectionClick = (section) => {
    setSelectedSection(section);
    setSelectedCategory(null);
    setSelectedSubCategory(null);
  };

  const handleAboutUsClick = (id) => {
    navigate(`/about-us-section#${id}`);
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        const yOffset = -120;
        const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 100);
    onClose();
    resetNav();
  };

  const handleCategoryClick = (category, event) => {
    event.stopPropagation();
    setSelectedCategory(category);
    setSelectedSubCategory(null);
  };

  const handleSubCategoryClick = (subCategory, event) => {
    event.stopPropagation();
    setSelectedSubCategory(subCategory);
  };

  const handleProductClick = (product, event) => {
    event.stopPropagation();
    if(product.subCategorySlug) {
    navigate(`/Products/${product.categorySlug}/${product.subCategorySlug}/${product.productSlug}`, { state: { product } });
    onClose();
    resetNav();
    }else{
      navigate(`/Products/${product.categorySlug}/${product.productSlug}`, { state: { product } });
      onClose();  
      resetNav();
    }
  };

 const handleServiceClick = (service, event) => {
  event.stopPropagation();
  navigate(`/service-description/${encodeURIComponent(service.title)}`);
  onClose();
  resetNav();
};

  const resetNav = () => {
    setSelectedSection(null);
  };

  const handleGoBack = () => {
    if (selectedSubCategory) {
      setSelectedSubCategory(null);
    } else if (selectedCategory) {
      setSelectedCategory(null);
    } else {
      setSelectedSection(null);
    }
  };

  const aboutUsSections = [
    { title: "Who We Are", id: "who-we-are-section" },
    { title: "What We Do", id: "what-we-do-section" },
    { title: "Sourcing Methodology", id: "sourcing-methodology" },
    { title: "Vision, Mission, Values", id: "vision-mission-value-section" }
  ];

  return (
    <div className={`nav-drawer ${isOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
      <ul>
        {selectedSection ? (
          <>
            <li className="mob-arrow go-back" onClick={handleGoBack}>←</li>

            {selectedSection === "about-us" ? (
              aboutUsSections.map((about, index) => (
                <li className="mob-service" key={index} onClick={() => handleAboutUsClick(about.id)}>
                  {about.title}
                </li>
              ))
            ) : selectedSection === "products" ? (
              selectedCategory ? (
                selectedSubCategory ? (
                  <ul>
                    {selectedSubCategory.products.map((product) => (
                      <li className="products-mob" key={product._id} onClick={(e) => handleProductClick(product, e)}>
                        {product.prodName}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <>
                    {selectedCategory.subCat.map((subCat) => (
                      <li className="dropdowncat" key={subCat.subCategorySlug} onClick={(e) => handleSubCategoryClick(subCat, e)}>
                        <span>{subCat.subCatName}</span>
                        <span className="mob-arrow">→</span>
                      </li>
                    ))}

                    {selectedCategory.products.length > 0 && (
                      <ul>
                        {selectedCategory.products.map((product) => (
                          <li className="products-mob2" key={product._id} onClick={(e) => handleProductClick(product, e)}>
                            {product.prodName}
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                )
              ) : (
                products.categories.map((category) => (
                  <li key={category.categorySlug} onClick={(e) => handleCategoryClick(category, e)} className="category-item">
                    <span>{category.category.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}</span>
                    <span className="mob-arrow">→</span>
                  </li>
                ))
              )
            ) : selectedSection === "services" ? (
              services.map((service, index) => (
                <li className="mob-service" key={index} onClick={(e) => handleServiceClick(service, e)}>
                  {service.title.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}

                </li>
              ))
            ) : null}
          </>
        ) : (
          <>
            <li onClick={(e) => { navigate("/"); onClose(); }}>HOME</li>

            <li className="dropdown" onClick={() => handleSectionClick("about-us")}>
              <div className="dropdown-toggle">
                ABOUT US
                <span className="mob-arrow">→</span>
              </div>
            </li>

            <li className="dropdown" onClick={() => handleSectionClick("products")}>
              <div className="dropdown-toggle">
                PRODUCTS
                <span className="mob-arrow">→</span>
              </div>
            </li>

            <li className="dropdown" onClick={() => handleSectionClick("services")}>
              <div className="dropdown-toggle">
                SERVICES
                <span className="mob-arrow">→</span>
              </div>
            </li>

            <li onClick={(e) => { navigate("/career"); onClose(); }}>CAREER</li>
            <li onClick={(e) => { navigate("/gallery"); onClose(); }}>GALLERY</li>
            <li onClick={(e) => { navigate("/contact-us"); onClose(); }}>CONTACT US</li>
          </>
        )}
      </ul>
    </div>
  );
};

export default NavDrawer;
